export const EMAIL_CONFIRMED_SUCCESS = 'email_confirmed_success';